import { render } from "./CasePersonalData.vue?vue&type=template&id=227e4a08&scoped=true&ts=true"
import script from "./CasePersonalData.vue?vue&type=script&lang=ts"
export * from "./CasePersonalData.vue?vue&type=script&lang=ts"

import "./CasePersonalData.vue?vue&type=style&index=0&id=227e4a08&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227e4a08"]])

export default __exports__